<template>
  <div>
    <transition name="overlay">
      <div class="overlay" v-if="open"></div>
    </transition>
    <transition name="fade">
      <div
        v-if="open"
        class="modal"
        @click="$emit('closePopup')"
      >
        <div class="modal__wrapper" :class="{ open: open }">
          <div class="slot" @click.stop>
            <slot></slot>
            <div style="
                height: 34px;
                width: 34px;
                flex-wrap: wrap;
                align-content: center;
                position: absolute;
                text-align: center;
                top: 20px;
                right: 15px;
                display: flex;
                align-items: center;
                justify-content: center;">
              <p v-if="hasCloseButton" @click="$emit('closePopup')" class="close-btn">+</p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    hasCloseButton: {
      type: Boolean,
      default: true
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../assets/scss/modal.scss';
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue